import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=9f0341ca&scoped=true&"
import script from "./Profile.vue?vue&type=script&lang=ts&"
export * from "./Profile.vue?vue&type=script&lang=ts&"
import style0 from "./Profile.vue?vue&type=style&index=0&id=9f0341ca&lang=less&scoped=true&"
import style1 from "./Profile.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f0341ca",
  null
  
)

export default component.exports